import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

import { format } from 'date-fns';

const formatNumber = (num) => {
    return new Intl.NumberFormat("id-ID").format(num);
};

function PdfGenerator ({ vendorData }) {
    const itemsData = [
        { itemName: ' ', currency:"\nRp", quantity: `\n${formatNumber(vendorData.furnitureSellingPrice)}`, currTotal:"", total:"" },
        { itemName: 'Total', currency:"Rp", quantity: `${formatNumber(vendorData.furnitureSellingPrice)} `, currTotal:"", total:""},
        {
            itemName: '',
            currency: `\n\nRp${vendorData.isPrintedTermin1 && vendorData.type > 1 ? "\nRp" : ''}${vendorData.isPrintedTermin2 && vendorData.type > 2 ? "\nRp" : ''}${vendorData.isPrintedTermin3 && vendorData.type > 3 ? "\nRp" : ''}${vendorData.isPrintedTermin4 && vendorData.type > 4 ? "\nRp" : ''}`,
            quantity: `\n\n${formatNumber(vendorData.comfee)}${vendorData.isPrintedTermin1 && vendorData.type > 1 ? "\n" + formatNumber(vendorData.termin1) : ''}${vendorData.isPrintedTermin2 && vendorData.type > 2 ? "\n" + formatNumber(vendorData.termin2) : ''}${vendorData.isPrintedTermin3 && vendorData.type >  3? "\n" + formatNumber(vendorData.termin3) : ''}${vendorData.isPrintedTermin4 && vendorData.type > 4 ? "\n" + formatNumber(vendorData.termin4) : ''}`,
            currTotal: "",
            total: ""
          },
        { itemName: 'Total yang sudah dibayar',  currency:"Rp", quantity: `${formatNumber(vendorData.totalPaid)} `, currTotal:"", total:""},
        { itemName: '', currency:"\n\nRp", quantity: `\n\n${formatNumber(vendorData.terminValue)}`, currTotal:"", total:"" },
        { itemName: 'Total Tagihan ', currency:"Rp", quantity: `${formatNumber(vendorData.terminValue)} `, currTotal:"Rp", total:`${formatNumber(vendorData.terminValue)} ` }
    ];

    const pdf = new jsPDF({
        unit: "mm", 
        format: "a4"
    });

    pdf.setProperties({
        title: "Invoice Termin"
    });

    
    pdf.setFontSize(15);
    pdf.setFont('helvetica', 'normal');
    pdf.setTextColor(100, 100, 100);
    pdf.text(`${vendorData.companyName}`, 28, 30);
    pdf.setFontSize(13);
    pdf.setTextColor(0, 0, 0);
    pdf.text('Invoice', 28, 36);
   
    pdf.setFontSize(9);
    pdf.text(format(new Date(), 'dd-MMM-yyyy'), 165, 39);

    pdf.setFont('helvetica', 'normal');
    pdf.text(vendorData.address, 28, 46);
    pdf.text(vendorData.city, 28, 50);
    // pdf.text(vendorData.city, 28, 50);
    
    pdf.setFont('helvetica', 'bold');
    pdf.text('Kpd Yth,', 28, 64);
    pdf.text(vendorData.clientName, 28, 68);
    pdf.text(vendorData.projectLocation, 28, 72);
    
    const itemDetailsRows = itemsData?.map((item, index) => [
        // (index + 1).toString(),
        item.itemName.toString(),
        item.currency.toString(),
        item.quantity.toString(),
        item.currTotal.toString(),
        item.total?.toString()
    ]);
    const itemDetailsHeaders = ['KETERANGAN', '', '' ,'TOTAL', ''];
    const columnWidths = [75, 10, 30, 10, 30];

    const headerStyles = {
        fillColor: [240, 240, 240],
        textColor: [0],
        fontFamily: 'Newsreader',
        fontStyle: 'bold',
    };

    const itemDetailsYStart = 76;

    autoTable(pdf, {
        head: [itemDetailsHeaders],
        body: itemDetailsRows,
        startY: itemDetailsYStart,
        theme: 'grid',
        styles: {
            lineWidth: 0.5,
            lineColor: [0, 0, 0],
            cellPadding: 0, // Reduce spacing inside cells
            fontSize: 10, 
            textColor: [0, 0, 0], // Black text
        }, 
        headStyles: {
            fillColor: [160, 160, 160],
            textColor: [0, 0, 0],
            lineColor: [0, 0, 0],
            fontStyle: "bold",
            fontSize: 9.5,
            font: "helvetica",
            halign: "center",
            lineWidth: 0.5,
            cellPadding: { top: 1, bottom: 1, left: 0 }
        },
        columnStyles: {
            0: { cellWidth: columnWidths[0], halign: "left" },
            1: { cellWidth: columnWidths[1], halign: "left" },
            2: { cellWidth: columnWidths[2], halign: "right" },
            3: { cellWidth: columnWidths[3], halign: "left" },
            4: { cellWidth: columnWidths[4], halign: "right" }
        },
        bodyStyles: {
            fontSize: 9.5,
            font: "helvetica",
            textColor: [0, 0, 0],
            lineColor: [0, 0, 0],
            lineWidth: 0.5,
            cellPadding: { top: 2, right: 2, bottom: 1, left: 2 },
        },
        alternateRowStyles: { fillColor: [255, 255, 255] },
        didDrawCell: (data) => {
            if (data.section === "body" && data.column.index === 0 && data.row.index === 0) {
                const doc = data.doc;
                let { x, y } = data.cell;
                x = x + 2
                y = y + 4

                const text = "Perincian :";

                doc.setFont("helvetica", "bolditalic");
                doc.setTextColor(0, 0, 0);
                doc.text("Perincian : ", x, y);

                const textWidth = doc.getTextWidth(text);
                doc.setLineWidth(0.2); // Adjust line thickness
                doc.line(x, y + 0.5, x + textWidth, y + 0.5);

                doc.setFont("helvetica", "italic");
                doc.text("Furniture", x, y + 5);
            }

            if (data.section === "body" && data.column.index === 0 && data.row.index === 2) {
                let terminType1 = vendorData.isPrintedTermin1 && vendorData.type > 1 ? "Termin 1" : "";
                let terminType2 = vendorData.isPrintedTermin2 && vendorData.type > 2 ? "Termin 2" : "";
                let terminType3 = vendorData.isPrintedTermin3 && vendorData.type > 3 ? "Termin 3" : "";
                let terminType4 = vendorData.isPrintedTermin4 && vendorData.type > 4 ? "Termin 4" : "";

                const doc = data.doc;
                let { x, y } = data.cell;
                x = x + 2
                y = y + 6

                const text = "Sudah terbayar :";

                doc.setFont("helvetica", "bolditalic");
                doc.setTextColor(0, 0, 0);
                doc.text(text, x, y);

                const textWidth = doc.getTextWidth(text);
                doc.setLineWidth(0.2); // Adjust line thickness
                doc.line(x, y + 0.5, x + textWidth, y + 0.5);

                doc.setFont("helvetica", "italic");
                doc.text("Comfee ", x, y + 6.2);
                doc.text(terminType1, x, y + 10);
                doc.text(terminType2, x, y + 14);
                doc.text(terminType3, x, y + 18);
                doc.text(terminType4, x, y + 22);
            }

            if (data.section === "body" && data.column.index === 0 && data.row.index === 4) {
                const doc = data.doc;
                let { x, y } = data.cell;
                x = x + 2
                y = y + 8

                const text = "Penagihan";

                doc.setFont("helvetica", "bolditalic");
                doc.setTextColor(0, 0, 0);
                doc.text(text, x, y);

                const textWidth = doc.getTextWidth(text);
                doc.setLineWidth(0.2); // Adjust line thickness
                doc.line(x, y + 0.5, x + textWidth, y + 0.5);

                doc.setFont("helvetica", "italic");
                doc.text(vendorData.typeName, x, y + 5);
            }
        },
        didParseCell: function (data) {
            if (data.row.index % 2 === 1 && data.section === "body") {
                data.cell.styles.fillColor = [160, 160, 160];
                data.cell.styles.valign = "middle"
                data.cell.styles.fontStyle = "bold"; 
                data.cell.styles.cellPadding = { top: 0.7, right: 1, bottom: 0.7, left: 2 };
                if (data.column.index === 0) {
                    data.cell.styles.fontStyle = "bolditalic"
                }
            }

            if (data.row.index % 2 === 0 && data.section === "body") {
                data.cell.styles.minCellHeight = 20; 
            }
    
            // if (data.section === "head" && data.row.index === 0 && data.column.index === 4) {
            //     data.cell.styles.lineWidth = { top: 0.5, right: 0.5, bottom: 1, left: 0.5 };
            //     data.cell.hidden = true;
            // }

            if (data.row.index === 0) {
                data.cell.styles.lineWidth = { top: 0.5 , left: 0.5, bottom: 1 };
            }
            
            if (data.column.index === 1 || data.column.index === 3) {
                data.cell.styles.lineWidth = { top: 0.5, right: 0, bottom: 1, left: 0.5 };
            }

            if (data.column.index === 2 || data.column.index === 4) {
                data.cell.styles.lineWidth = { top: 0.5, right: 0.5, bottom: 1, left: 0 };
            }

            if (data.section === "body") {
                data.cell.styles.lineWidth = { top: 0, right: 0.5, bottom: 0, left: 0.5};
            }
            if (data.section === "body" && (data.column.index === 1 || data.column.index === 3)) {
                data.cell.styles.lineWidth = { top: 0, right: 0, bottom: 0, left: 0.5 };
            }
        
            // Remove left border of "1000" column (assuming it's column index 2)
            if (data.section === "body" && (data.column.index === 2 || data.column.index === 4)) {
                data.cell.styles.lineWidth = { top: 0, right: 0.5, bottom: 0, left: 0 };
            }

            if (data.row.index === data.table.body.length - 1){
                data.cell.styles.lineWidth = { top: 0, right: 0, bottom: 0.5, left: 0.5 };
            }

            if (data.row.index === data.table.body.length - 1 && (data.column.index === 2 || data.column.index === 4)){
                data.cell.styles.lineWidth = { top: 0, right: 0.5, bottom: 0.5, left: 0 };
            }

            if (data.section === "head" && data.row.index === 0 && data.column.index === 3) {
                data.cell.colSpan = 2
                data.cell.styles.halign = "center";
                data.cell.styles.lineWidth = { top: 0.5, right: 0.5, bottom: 1, left: 0.5};
            }

            if (data.row.index === data.table.body.length - 1 && (data.column.index === 1 || data.column.index === 3)){
                data.cell.styles.lineWidth = { top: 0, right: 0, bottom: 0.5, left: 0.5 };
            }
        },
        styles: { rowPageBreak: "avoid" },
        margin: { top: 10, left: 28 },
    
        // Draw double outside borders
        didDrawTable: function (data) {
            let table = data.table;
            let x = table.startX;
            let y = table.startY;
            let w = table.width;
            let h = table.height;

            pdf.setDrawColor(0);

            pdf.setLineWidth(1);
            pdf.rect(x, y, w, h, "S");

            pdf.setDrawColor(0);
            pdf.setLineWidth(0.5);
            pdf.setLine(0.5);
            pdf.rect(x - 1, y - 1, w + 2, h + 2, "S");
        },
    });

    // Add summary and page numbers
    const summaryYStart = pdf.lastAutoTable.finalY + 10;

    pdf.setFont('helvetica', 'bolditalic');
    pdf.text('Pembayaran ditujukan ke Rek.', 28, summaryYStart);

    pdf.setFont('helvetica', 'bold');
    pdf.text('Hormat kami', 155, summaryYStart);

    pdf.setFont('helvetica', 'bolditalic');
    pdf.text('Bank Name', 28, summaryYStart + 5);
    pdf.setFont('helvetica', 'bold');
    pdf.text(':', 56, summaryYStart + 5);
    pdf.text(` ${vendorData.bankName}`, 57, summaryYStart + 5);
    pdf.text('Account Name', 28, summaryYStart + 10);
    pdf.setFont('helvetica', 'bold');
    pdf.text(': ', 56, summaryYStart + 10);
    pdf.text(` ${vendorData.companyName}`, 57, summaryYStart + 10);

    pdf.setFont('helvetica', 'bolditalic');
    pdf.text('Account Number', 28, summaryYStart + 15);
    pdf.setFont('helvetica', 'bold');
    pdf.text(': ', 56, summaryYStart + 15);
    pdf.text(`${vendorData.bankName} - ${vendorData.accountNumber}`, 58, summaryYStart + 15);

    pdf.text(` ${vendorData.companyName}`, 153, summaryYStart + 35);

    const pdfDataUri = pdf.output('datauristring'); // Get the PDF in a data URI format

    const link = document.createElement('a');
    link.href = pdfDataUri;
    link.download = 'RFQ.pdf';
    link.click();

    const newTab = window.open();
    newTab?.document.write(`<iframe width='100%' height='100%' src='${pdfDataUri}'></iframe>`);
}

export default PdfGenerator